// A snake, modelled facing +X: a chain of tapering body segments laid in a gentle
// S, with a small wedge head. Ported 1:1 from age-of-mcp's classic snake.ts,
// restoring its deterministic segment loop (radius taper + sinusoidal S-weave).
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  // Body: segments back from the head along -X, weaving in Z for an S-curve.
  const segs = 7;
  for (let i = 0; i < segs; i++) {
    const t = i / (segs - 1);
    const r = 0.016 * (1 - t * 0.6);
    parts.push({ geometry: new THREE.IcosahedronGeometry(r, 0),
      color: i % 2 === 0 ? "#4a7a32" : "#5e8a3e",
      position: [0.04 - i * 0.024, 0.014, Math.sin(t * Math.PI * 2) * 0.02] });
  }
  parts.push(
    { geometry: new THREE.ConeGeometry(0.016, 0.03, 4), color: "#5e8a3e",
      position: [0.07, 0.014, 0], rotation: [0, 0, -Math.PI / 2] },    // head
    { geometry: new THREE.IcosahedronGeometry(0.003, 0), color: "#d4b020",
      position: [0.082, 0.018, 0.007] },                             // eye
    { geometry: new THREE.IcosahedronGeometry(0.003, 0), color: "#d4b020",
      position: [0.082, 0.018, -0.007] },
  );
  return parts;
}

export const snake = defineModel({
  id: "snake",
  batchId: "standard",
  name: "Snake",
  tags: ["creature","snake","low-poly","age-of-mcp","classic"],
  summary: "Low-poly snake.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: () => partsFor(),
  animations: [],
});
